import React, { useState } from "react";
import "C:/Users/yrsha/client1/src/App.css"; 

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    attachment: null, // File attachment
  });

  const [status, setStatus] = useState("");
  const [fileName, setFileName] = useState("");

  // Handle input changes for text fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file changes for attachment
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevState) => ({
          ...prevState,
          attachment: {
            name: file.name,
            content: reader.result.split(",")[1], // Extract Base64 content
            type: file.type,
          },
        }));
      };
      reader.readAsDataURL(file); // Convert file to Base64
      setFileName(file.name);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch("https://taasengg.com/php/sendEmail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", message: "", attachment: null });
        setFileName("");
      } else {
        setStatus("Failed to send the message. Please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("Error occurred. Please try again.");
    }
  };

  return (
    <div className="contact-page py-5">
      <div className="animated-heading">
        <h1 className="contact-heading">Contact</h1>
      </div>

      {/* New Location Section */}
      <div className="location-section container py-5">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.8675732639367!2d55.40526899999999!3d25.3422244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f596254fc5983%3A0x334cfba71b3001e3!2sTAAS%20Rewinding%20Electrical!5e0!3m2!1sen!2sin!4v1735158019273!5m2!1sen!2sin"
          width="100%"
          height="250"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        ></iframe>
      </div>

      <div className="container py-5">
        <div className="row align-items-start">
          {/* "How Can We Help" Section */}
          <div className="col-md-6 contact-info animated-fade-in">
            <h5>HOW CAN WE HELP?</h5>
            <p>
              Taas Elect Motor Winding Services,
              <br />
              Industrial Area 4, Behind Danube,
              <br />
              Shed 18, P. O. Box 20997, Sharjah UAE
              <br />
              <a href="tel:+971527499912" className="text-black text-decoration-none">
                +971-52749-9912
              </a>
              <br />
              <a
                href="mailto:raj@taasengg.com"
                className="text-black text-decoration-none"
              >
                raj@taasengg.com
              </a>
            </p>
          </div>

          {/* Contact Form Section */}
          <div className="col-md-6 animated-fade-in">
            <h5 className="mb-4">CONTACT US</h5>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="3"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              {/* Attachment Input */}
              <div className="mb-3">
                <label htmlFor="attachment" className="form-label">
                  Attachment (optional)
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="attachment"
                  accept="image/*, application/pdf"
                  onChange={handleFileChange}
                />
                {fileName && <p className="mt-1">Selected file: {fileName}</p>}
              </div>
              <button type="submit" className="btn btn-primary w-100 submit-button animated-button">
                Submit
              </button>
            </form>
            {status && <p className={`mt-3 status-message ${status.includes("success") ? "text-success" : "text-danger"}`}>{status}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
